<template>
	<div id="Neighborhood_Analysis" class="map">
		<div class="map-inner-cont">
			<Map
				v-if="property"
				:id="property.id"
				:mainAddress="property.address"
				:neighborAddresses="property.comparedChart.slice(1)"
				:city="city"
			/>
		</div>
		<div class="map-summary-card card">
			<div class="map-header-sec">
				<div class="header5">Neighborhood</div>
				<div class="header3">Analysis</div>
			</div>
			<div class="map-results-sec">
				<PropMapInfoElement
					:mapInfoValue="comparedTable[0].count.toString()"
					mapInfoLabel="Total Properites in Neighborhood"
					mapIconName="numberOfProperties.svg"
				/>
				<PropMapInfoElement
					:mapInfoValue="comparedTable[2].count.toString()"
					mapInfoLabel="Total Comparable Properties"
					mapIconName="property-classification.svg"
				/>
				<PropMapInfoElement
					:mapInfoValue="comparedTable[0].buildingSqFt | numberWithCommas"
					mapInfoLabel="Median Assessment/SqFt in Neighborhood"
					mapIconName="medianAssessmentOfAllProp.svg"
				/>
				<PropMapInfoElement
					:mapInfoValue="comparedTable[2].buildingSqFt | numberWithCommas"
					mapInfoLabel="Median Assessment/SqFt of Comparable Properties"
					mapIconName="medianAssessmentOfComp.svg"
				/>
			</div>
			<ComparedChart :comparedChart="property.comparedChart" />
			<span v-if="isOverAssessed"
				>This means that your property is a good candidate for an appeal and stands a strong chance of winning a reduction.</span
			>
			<div class="button-cont" @click="goResult">
				<i class="material-icons arrow-link">east</i>
				<div class="link-button">What does this mean for me?</div>
			</div>
		</div>
	</div>
</template>

<script>
import Map from "@/components/Map.vue";
import ComparedChart from "@/components/property/ComparedChart.vue";
import { assessmentStatus } from "@/env";
import PropMapInfoElement from "@/components/property/PropMapInfoElement.vue";
import ComparedTable from "@/components/property/ComparedTable.vue";

export default {
	name: "property-map",
	components: {
		Map,
		ComparedChart,
		PropMapInfoElement,
		ComparedTable,
	},
	computed: {
		// property() {
		// 	return this.$store.state.property.propertyData;
		// },

		comparedTable() {
			return this.$store.getters.getAllPropertyData.comparedTable;
		},
		property() {
			return this.$store.getters.getAllPropertyData;
		},
		isOverAssessed() {
			return this.$store.getters.getAssessmentRate === assessmentStatus.overAssessed;
		},
		assessment() {
			let assessment;
			switch (this.$store.getters.getAssessmentRate) {
				case assessmentStatus.underassessed: // "Underasssesed":
					assessment = "Fairly";
					break;
				case assessmentStatus.overAssessed: // "Overassessed":
					assessment = "Over";
					break;
				case assessmentStatus.fairlyAssessed: // "Assesed Fairly":
					assessment = "Fairly";
					break;
				default:
					assessment = "not";
			}
			return `${assessment}`;
		},
		city() {
			const cityObj = this.property.propertySummary.city;
			if (cityObj) {
				return cityObj;
			} else {
				return "";
			}
		},
	},
	methods: {
		goResult() {
			this.scroll("#Property_Result");
		},
		scroll(to) {
			const element = document.querySelector(to);
			let offset = 56;

			window.scrollTo({
				top: element.offsetTop - offset,
				left: 0,
				behavior: "smooth",
			});
		},
	},
};
</script>

<style scoped lang="scss">
.map {
	display: flex;
	min-height: 1000px;
	position: relative;
	text-align: left;
	flex-direction: column;
	.leaflet-pane {
		z-index: unset !important;
	}
	.header5 {
		color: var(--accent);
	}
	.header3 {
		font-size: 36px;
		line-height: 36px;
		color: var(--black);
		margin-top: 8px;
	}
	.results-title {
		font-size: 25px;
		margin-bottom: 15px;
	}
	.map-inner-cont {
		// width: 100vw;
		width: 100%;
		object-fit: cover;
		z-index: 0;
	}
	.map-summary-card {
		position: absolute;
		width: 675px;
		z-index: 600;
		// top: 10vh;
		top: 7vh;
		left: 60px;
		padding: 3em;
		.map-header-sec {
			margin-bottom: 30px;
		}
		.map-results-sec {
			display: grid;
			grid-template-columns: repeat(auto-fit, minmax(226px, 1fr));
		}
		.map-card-text {
			font-weight: 400;
			font-size: 36px;
			line-height: 36px;
			color: var(--primary);
		}
		.map-card-cont {
			margin-top: 35px;
			display: flex;
			flex-direction: row;
			flex-wrap: wrap;
			justify-content: space-around;
		}
		.prop-map-info-element {
			margin-bottom: 30px;
		}
	}

	.card-cont {
		padding: 30px 20px;
		display: grid;
		grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
		max-width: 875px;
		align-items: center;
	}
	.link-button {
		color: var(--accent);
		margin-top: 8px;
		font-weight: 500;
		font-size: 18px;
		cursor: pointer;
		border-bottom: 2px solid var(--accent);
		line-height: 30px;
	}
	.arrow-link {
		background: var(--accent);
		color: white;
		border-radius: 20px;
		margin-left: 10px;
		padding: 6px;
		cursor: pointer;
	}
	.button-cont {
		text-align: left;
		display: flex;
		flex-direction: row-reverse;
		align-items: flex-end;
		max-width: 1600px;
		margin: 0 auto;
		width: 100%;
		z-index: 9;
		margin-top: 25px;
	}
}

@media screen and (max-width: 1366px) {
	.map {
		flex-direction: column;
		.map-summary-card {
			position: relative;
			width: unset;
			top: unset;
			left: unset;
			bottom: 0;
			margin: 0 60px;
			.map-header-sec {
				padding-left: unset;
			}
			.map-results-sec {
				padding: 0 40px;
			}
			.compared-chart {
				display: flex;
				justify-content: center;
			}
		}

		.card-cont {
			display: grid;
			grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
			max-width: unset;
			align-items: center;
			grid-gap: 25px;
		}
	}
}
@media screen and (max-width: 768px) {
	.map {
		flex-direction: column;
		.map-summary-card {
			position: relative;
			width: unset;
			top: unset;
			left: unset;
			bottom: 0;
			margin: 0 60px;
			.map-header-sec {
				padding-left: unset;
			}
			.map-results-sec {
				padding: 0 40px;
			}
			.compared-chart {
				display: flex;
				justify-content: center;
			}
		}

		.card-cont {
			display: grid;
			grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
			max-width: unset;
			align-items: center;
			grid-gap: 25px;
		}
	}
}
@media screen and (max-width: 414px) {
	.map {
		.map-summary-card {
			margin: unset;
			bottom: 96px;
			padding-bottom: 40px;
			.map-header-sec {
				padding-left: unset;
			}
			.map-results-sec {
				padding: 0 40px;
			}
			.compared-chart {
				display: none;
			}
		}
	}
}
</style>
